import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white py-4 text-center mt-6">
      <p>© 2025 गट ग्रामपंचायत सावंगी-घोगली
 | संपर्क: +919765016588</p>
    </footer>
  );
};

export default Footer;